<template>
  <App :session="session">
    <figure class="slide" style="display: flex; margin: 0">
      <img
        :src="banner.img"
        style="
          width: 100%;
          max-width: 1000px;
          max-height: 280px;
          transition: all 2s;
        "
        :style="{ opacity: op }"
      />
      <img
        :src="banner.img2"
        style="
          width: 100%;
          max-width: 1000px;
          max-height: 280px;
          transition: all 2s;
          transform: translate(-100%);
          opacity: 0;
        "
        :style="{ opacity: op2 }"
      />
      <img
        :src="banner.img3"
        style="
          width: 100%;
          max-width: 1000px;
          max-height: 280px;
          transition: all 2s;
          transform: translate(-200%);
          opacity: 0;
        "
        :style="{ opacity: op3 }"
      />
    </figure>
    <br />

    <h4>INICIO</h4>

    <i class="load" v-if="loading"></i>

    <div class="boxes" v-if="!loading">
      <!-- Campos que se muestran dinámicamente segun la configuraciión de "platform_configs" -->
      <div v-if="platform_configs.show_ballance.main" class="box blue">
        <i class="fas fa-wallet"></i>
        <div>
          <p>Bs {{ balance }}</p>
          <span>SALDO</span>
        </div>
      </div>
      <div class="box green">
        <i class="fas fa-hand-holding-usd"></i>
        <div>
          <p>Bs {{ _balance }}</p>
          <span>SALDO NO DISPONIBLE</span>
        </div>
      </div>
      <div v-if="platform_configs.show_ballance.aff" class="box green">
        <i class="fas fa-hand-holding-usd"></i>
        <div>
          <p>Bs {{ _balance_aff }}</p>
          <span>SALDO BONO AFILIADOS</span>
        </div>
      </div>
      <div v-if="platform_configs.show_ballance.earn" class="box green">
        <i class="fas fa-hand-holding-usd"></i>
        <div>
          <p>$ {{ Number(ins + insVirtual).toFixed(2) }}</p>
          <span>TOTAL GANADO</span>
        </div>
      </div>

      <div class="box yellow">
        <i class="fas fa-medal"></i>
        <div>
          <p>{{ points }}</p>
          <span>PUNTOS</span>
        </div>
      </div>

      <div class="box yellow" v-if="rank">
        <i class="fas fa-gem"></i>
        <div>
          <p>{{ rank | _rank }}</p>
          <span>RANGO CERRADO</span>
        </div>
      </div>

      <div class="box yellow" v-if="node">
        <i class="fas fa-gem"></i>
        <div>
          <p>{{ node.rank | _rank }}</p>
          <span>RANGO ACTUAL</span>
        </div>
      </div>

      <!-- <div class="box yellow" v-if="node">
        <i class="fa fa-tachometer"></i>
        <div>
          <p>{{ node.next_rank.name | _rank }}</p>
          <span>SIGUIENTE RANGO</span>
        </div>
      </div> -->

      <!-- <div class="box yellow" v-if="node">
        <i class="fas fa-hand-holding-usd"></i>
        <div>
          <p>Bs {{ node.residual_bonus }}</p>
          <span>RESIDUAL ACTUAL</span>
        </div>
      </div> -->


    </div>

    <!-- <br /><br />

    <h4>PUNTOS GRUPALES</h4>

    <table v-if="node">
      <thead>
        <tr>
          <th></th>
          <th v-for="(points, i) of node._total" :key="i">F {{ i + 1 }}</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>Acumulado</td>
          <td v-for="(points, i) of node._total" :key="i">{{ points }}</td>
        </tr>
        <tr>
          <td>Compras</td>
          <td v-for="(points, i) of node._total_only_points" :key="i">
            {{ points }}
          </td>
        </tr>
        <tr>
          <td>Afiliación</td>
          <td v-for="(points, i) of node._total_only_aff_points" :key="i">
            {{ points }}
          </td>
        </tr>
      </tbody>
    </table> -->
    <br />
  </App>
</template>

<script>
import App from '@/views/layouts/App'
import api from '@/api'

export default {
  components: {
    App,
  },
  data() {
    return {
      platform_configs: null,
      banner: { img: null },
      ins: null,
      outs: null,
      balance: null,
      _balance: null,
      _balance_aff: null,
      team: null,
      rank: null,
      points: null,
      dateStartPlan: null,
      directs_found: null,
      bonus_by_directs: null,

      loading: true,

      op: 1,
      op2: 0,
      op3: 0,
    }
  },
  computed: {
    /**
     * @return {String}
     */
    session() {
      return this.$store.state.session
    },
    /**
     * @return {String}
     */
    plan() {
      return this.$store.state.plan
    },
  },
  filters: {
    _rank(val) {
      // if (val == 'active') return 'Activo'
      // if (val == 'ambassador') return 'Embajador'
      // if (val == 'master') return 'Master'
      // if (val == 'quartz') return 'Cuarzo'
      // if (val == 'sapphire') return 'Zafiro'
      // if (val == 'ruby') return 'Rubí'
      // if (val == 'emerald') return 'Esmeralda'
      // if (val == 'diamond') return 'Diamante'
      // if (val == 'imperial-diamond') return 'Diamante Imperial'
      // if (val == 'crown-diamond') return 'Diamante Corona'
      // if (val == 'silver') return 'Plata'
      // if (val == 'star') return 'Estrella'
      if (val == 'none') return 'Ninguno'
      // if (val == 'gold') return 'ORO'

      return val
    },
  },
  async created() {
    // GET data
    const { data } = await api.dashboard(this.session)
    console.log({ data })

    this.loading = false

    // error
    if (data.error && data.msg == 'invalid session') this.$router.push('/login')

    // success
    this.$store.commit('SET_NAME', data.name)
    this.$store.commit('SET_LAST_NAME', data.lastName)
    this.$store.commit('SET_AFFILIATED', data.affiliated)
    this.$store.commit('SET_ACTIVATED', data.activated)
    this.$store.commit('SET__ACTIVATED', data._activated)
    this.$store.commit('SET_PLAN', data.plan)
    this.$store.commit('SET_COUNTRY', data.country)
    this.$store.commit('SET_PHOTO', data.photo)
    this.$store.commit('SET_TREE', data.tree)

    this.platform_configs = data.platform_configs
    this.banner = data.banner
    this.ins = data.ins
    this.insVirtual = data.insVirtual
    this.outs = data.outs.toFixed(2)
    this.balance = data.balance.toFixed(2)
    this._balance = data._balance.toFixed(2)
    this._balance_aff = data._balance_aff ? data._balance_aff.toFixed(2) : 0
    this.team = data.team
    this.rank = data.rank
    this.points = data.points
    this.node = data.node
    this.n_affiliates = data.n_affiliates
    this.dateStartPlan = data.dateStartPlan
    this.days_to_expire = data.days_to_expire
    this.directs_found = data.directs_found
    this.bonus_by_directs = data.bonus_by_directs

    const time = 4000
    let i = 0
    const n = 3

    setInterval(() => {
      i += 1
      console.log(i)

      if (i == 0) {
        // reset all
        this.op = 0
        this.op2 = 0
        this.op3 = 0
        // show 0
        this.op = 1
      }

      if (i == 1) {
        // reset all
        this.op = 0
        this.op2 = 0
        this.op3 = 0
        // show 0
        this.op2 = 1
      }

      if (i == 2) {
        // reset all
        this.op = 0
        this.op2 = 0
        this.op3 = 0
        // show 0
        this.op3 = 1
      }

      if (i == n - 1) i = -1
    }, time)
  },
}
</script>
